import './async.style.sass';
import template from './async.tpl.pug';

export const selector = 'dbAAsync';

const CLASS_ASYNC = 'async';
const CLASS_LOADING = `${CLASS_ASYNC}-loading`;
const CLASS_DISABLED = 'disabled';

/* @ngInject */
export default function AsyncDirective($q) {
    return {
        restrict: 'A',
        template: template(),
        transclude: {
            initial: 'initial',
            loading: 'loading'
        },
        scope: {
            loading: '=',
            disabled: '=ngDisabled',
            onClick: '&'
        },
        
        link: (scope, element) => {
            let promise = null;

            toggleClass(CLASS_ASYNC, true);

            scope.$watch(getLoadingStatus, updateState);
            scope.$watch(getDisabledStatus, updateState);

            element.on('click', clickHandler);
            scope.$on('$destroy', () => element.off('click', clickHandler));

            function clickHandler(event) {
                if (promise) {
                    event.preventDefault();
                } else {
                    scope.$applyAsync(() => promise = $q.when(scope.onClick()).finally(() => promise = null));
                }
            }

            function getLoadingStatus() {
                return !!(scope.loading || promise);
            }

            function getDisabledStatus() {
                return !!scope.disabled;
            }

            function updateState() {
                let loading = getLoadingStatus();

                toggleClass(CLASS_DISABLED, getDisabledStatus() || loading);
                toggleClass(CLASS_LOADING, loading);
            }

            function toggleClass(name, state) {
                if (state) {
                    element.addClass(name);
                } else {
                    element.removeClass(name);
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/async/async.directive.js